import { AlertNoticeTheme } from '../../types';

export const ALERT_NOTICE_DEFAULT_THEME: AlertNoticeTheme = {
    colors: {
        primary: {
            icon: 'primary.base',
            iconBg: 'primary.tint.100',
        },
        secondary: {
            icon: 'secondary.base',
            iconBg: 'secondary.tint.100',
        },
        tertiary: {
            icon: 'tertiary.base',
            iconBg: 'tertiary.tint.100',
        },
    },
};
